import { apiClient } from './apiClient';

const checkAuthToken = () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  if (!token) {
    throw {
      status: 401,
      message: 'Authentication required. Please sign in to manage address details.',
    };
  }
  return token;
};

export const addressService = {
  async saveAddress(addressData) {
    checkAuthToken();
    return apiClient.post('/address', addressData);
  },

  async getAddress(userId) {
    checkAuthToken();
    return apiClient.get(`/address/user/${userId}`);
  },

  async updateAddress(addressData) {
    checkAuthToken();
    return apiClient.put('/address', addressData);
  },

  async deleteAddress(id) {
    checkAuthToken();
    return apiClient.delete(`/address/${id}`);
  },
};
